export function isPopoverSupported(): boolean {
  return 'popover' in window.HTMLElement.prototype;
}
